"use client";
import React from "react";
import {
  Box,
  Grid,
  Card,
  Typography,
  CardContent,
  Stack,
  Divider,
  Link,
} from "@mui/material";
import { CompletedSignupIcon, ConversationTodayIcon, DeActivaredIcon, GhostUsersIcon, MarktingSignupIcon, NewSignupIcon, OnlineNowIcon, OrganicIcon, PendingTicketIcon, PlanViewdIcon, ProfileCompletionRateIcon, SuspendedUsersIcon, TotalUsersIcon, UnreadBotIcon, VerificationPendingIcon,InituateIcon, PaymentIcon } from "../../icons";
import { useDispatch, useSelector } from "react-redux";
import { useState } from "react";
import { fetchNyDashboardStatsData } from "../../api/nystats";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { setResetFilter, setStatsTypeFilter } from "../app-container/reducer/filterSlice";
import moment from "moment";

const StatRow = ({ label, count, percent }) => (
  <Box display="flex" justifyContent="space-between" sx={{ mt: 0.5 }}>
    <Typography variant="caption" color="text.secondary" sx={{ fontSize: '12px', color: '#757575' }}>
      {label}
    </Typography>
    <Typography variant="caption" color="text.secondary">
      {percent !== undefined && percent !== "" ? `${count} (${percent}%)` : `${count}`}
    </Typography>
  </Box>
);

// PROPER CARD COMPONENT
const DashboardCard = ({ card,handleNaviagtion }) => (
  <Box onClick={()=>handleNaviagtion && handleNaviagtion(card)} style={{cursor:card?.navigateUrl ? "pointer" : "default", textDecoration: "none", width: '100%', height: '100%', }}>
    <Card
      sx={{
        borderRadius: 2,
        boxShadow: "none",
        border: '1px solid #E8E8E8',
        bgcolor: card.accent,
        transition: '0.3s',
        height: '100%',
        "&:hover": {
          boxShadow: "0 0 10px rgba(0,0,0,0.3)",
          transform: "translateY(-3px)",
          border: '1px solid #ff4A4A',
        },
      }}
    >
      <CardContent>
        <Stack direction="row" justifyContent="space-between">
          <Typography sx={{ fontWeight: 500, fontSize: '14px', color: '#3C4043' }}>
            {card.title}
          </Typography>

          <Box sx={{ color: "primary.main" }}>{card.icon}</Box>
        </Stack>

        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mt: 1, }}>
          <Typography sx={{ fontWeight: 500, fontSize: '20px', color: '#000' }}>
            {card.value}
          </Typography>

          {/* Percentage (optional) */}
          {card.percentage && (
            <Typography
              variant="caption"
              sx={{ color: card.percentageColor, fontWeight: 500, fontSize: '16px' }}
            >
              {card.percentage}
            </Typography>
          )}
        </Box>

        {/* Breakdown rows */}
        {card.breakdown && (
          <Box sx={{ mt: 1.5 }}>
            {card.breakdown.map((row, i) => (
              <StatRow key={i} {...row} />
            ))}
          </Box>
        )}
      </CardContent>
    </Card>
  </Box>
);

export default function NewYorkCards() {
  const { filter } = useSelector((state) => state);
  const [cardsData, setCardsData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const dispatch = useDispatch()
  const navigate = useNavigate();
  // const cards = [
  //   {
  //     title: "TOTAL USERS",
  //     value: "250,456",
  //     icon: <TotalUsersIcon />,
  //     accent: "#fff",
  //     href: "/dashboard/new-signups",
  //     breakdown: [
  //       { label: "Organic Traffic", count: "9,858", percent: 40 },
  //       { label: "Marketing Traffic", count: "4,258", percent: 40 },
  //       // { label: "NON BINARY/OTHER", count: "4,258", percent: 20 },
  //     ],
  //   },
  //   {
  //     title: "NEW SIGN-UPS",
  //     value: "250,456",
  //     icon: <NewSignupIcon />,
  //     accent: "#fff",
  //     href: "/analytics",
  //     breakdown: [
  //       { label: "MALE", count: "9,858", percent: 40 },
  //       { label: "FEMALE", count: "4,258", percent: 40 },
  //       { label: "NON BINARY/OTHER", count: "4,258", percent: 20 },
  //     ],
  //   },
  //   {
  //     title: "ORGANIC SIGN-UPS",
  //     value: "8,754",
  //     icon: <OrganicIcon />,
  //     accent: "#fff",
  //     href: "/analytics",
  //     breakdown: [
  //       { label: "MALE", count: "9,858", percent: 40 },
  //       { label: "FEMALE", count: "4,258", percent: 40 },
  //       { label: "NON BINARY/OTHER", count: "4,258", percent: 20 },
  //     ],
  //   },
  //   {
  //     title: "MARKETING SIGN-UPS",
  //     value: "1,450",
  //     icon: <MarktingSignupIcon />,
  //     accent: "#fff",
  //     href: "/analytics",
  //     breakdown: [
  //       { label: "MALE", count: "9,858", percent: 40 },
  //       { label: "FEMALE", count: "4,258", percent: 40 },
  //       { label: "NON BINARY/OTHER", count: "4,258", percent: 20 },
  //     ],
  //   },
  //   {
  //     title: "COMPLETED SIGNUP",
  //     value: "250,456",
  //     icon: <CompletedSignupIcon />,
  //     accent: "#fff",
  //     href: "/user-management",
  //     breakdown: [
  //       { label: "MALE", count: "9,858", percent: 40 },
  //       { label: "FEMALE", count: "4,258", percent: 40 },
  //       { label: "NON BINARY/OTHER", count: "4,258", percent: 20 },
  //     ],
  //   },
  //   {
  //     title: "ONLINE NOW",
  //     value: "4,584",
  //     icon: <OnlineNowIcon />,
  //     accent: "#fff",
  //     percentage: "30%",
  //     percentageColor: "success.main",
  //     href: "/user-management",
  //     breakdown: [
  //       { label: "MALE", count: "9,858", percent: 40 },
  //       { label: "FEMALE", count: "4,258", percent: 40 },
  //       { label: "NON BINARY/OTHER", count: "4,258", percent: 20 },
  //     ],
  //   },
  //   {
  //     title: "GHOST USERS",
  //     value: "250,456",
  //     icon: <GhostUsersIcon />,
  //     accent: "#fff",
  //     href: "/user-management",
  //     breakdown: [
  //       { label: "MALE", count: "9,858", percent: 40 },
  //       { label: "FEMALE", count: "4,258", percent: 40 },
  //       { label: "NON BINARY/OTHER", count: "4,258", percent: 20 },
  //     ],
  //   },
  //   {
  //     title: "CONVERSATION",
  //     value: "4,584",
  //     icon: <ConversationTodayIcon />,
  //     accent: "#fff",
  //     percentage: "30%",
  //     percentageColor: "success.main",
  //     href: "/chat",
  //     breakdown: [
  //       { label: "MALE", count: "9,858", percent: 40 },
  //       { label: "FEMALE", count: "4,258", percent: 40 },
  //       { label: "NON BINARY/OTHER", count: "4,258", percent: 20 },
  //     ],
  //   },
  //   {
  //     title: "DE-ACTIVATED USERS",
  //     value: "4,584",
  //     icon: <DeActivaredIcon />,
  //     accent: "#fff",
  //     percentage: "10%",
  //     percentageColor: "error.main",
  //     href: "/user-management",
  //     breakdown: [
  //       { label: "MALE", count: "9,858", percent: 40 },
  //       { label: "FEMALE", count: "4,258", percent: 40 },
  //       { label: "NON BINARY/OTHER", count: "4,258", percent: 20 },
  //     ],
  //   },
  //   {
  //     title: "SUSPENDED USERS",
  //     value: "4,584",
  //     icon: <SuspendedUsersIcon />,
  //     accent: "#fff",
  //     percentage: "20%",
  //     percentageColor: "error.main",
  //     href: "/user-management",
  //     breakdown: [
  //       { label: "MALE", count: "9,858", percent: 40 },
  //       { label: "FEMALE", count: "4,258", percent: 40 },
  //       { label: "NON BINARY/OTHER", count: "4,258", percent: 20 },
  //     ],
  //   },
  //   {
  //     title: "PROFILE COMPLETION RATE",
  //     value: "80%",
  //     icon: <ProfileCompletionRateIcon />,
  //     accent: "#fff",
  //     href: "/",
  //     breakdown: [
  //       { label: "MALE", count: "9,858", percent: 40 },
  //       { label: "FEMALE", count: "4,258", percent: 40 },
  //       { label: "NON BINARY/OTHER", count: "4,258", percent: 20 },
  //     ],
  //   },
  //   {
  //     title: "PLAN VIEWED",
  //     value: "20",
  //     icon: <PlanViewdIcon />,
  //     accent: "#fff",
  //     href: "/financials",
  //     breakdown: [
  //       { label: "GOLD", count: "9,858", percent: 40 },
  //       { label: "LUXURY", count: "4,258", percent: 40 },
  //       // { label: "NON BINARY/OTHER", count: "4,258", percent: 20 },
  //     ],
  //   },
  //   {
  //     title: "VERIFICATION PENDING",
  //     value: "4",
  //     icon: <VerificationPendingIcon />,
  //     accent: "#fff",
  //     href: "/verification",
  //     breakdown: [
  //       { label: "SELFIE", count: 3, percent: "" },
  //       { label: "DOCUMENT", count: 1, percent: "" },
  //     ],
  //   },
  //   {
  //     title: "UNREAD BOT CHATS",
  //     value: "4",
  //     icon: <UnreadBotIcon />,
  //     accent: "#fff",
  //     href: "/bot-management",
  //     breakdown: [
  //       { label: "MALE", count: "9,858", percent: 40 },
  //       { label: "FEMALE", count: "4,258", percent: 40 },
  //       { label: "NON BINARY/OTHER", count: "4,258", percent: 20 },
  //     ],
  //   },
  //   {
  //     title: "PENDING TICKETS",
  //     value: "4",
  //     icon: <PendingTicketIcon />,
  //     accent: "#fff",
  //     href: "/QueryTicketManagement",
  //   },
  // ];
  const fetchData = async () => {
    try {
      setIsLoading(true);
      const data = await fetchNyDashboardStatsData(filter);
      const cards = data
        ? [
          {
            title: "TOTAL USERS",
            value: data.totalUsers.total,
            icon: <TotalUsersIcon />,
            accent: "#fff",
            href: "/user-management",
            breakdown: [
              { label: "MALE", count: data.totalUsers.male.count, percent: data.totalUsers.male.percentage.toFixed(1) },
              { label: "FEMALE", count: data.totalUsers.female.count, percent: data.totalUsers.female.percentage.toFixed(1) },
              { label: "NON BINARY/OTHER", count: data.totalUsers.nonBinaryOther.count, percent: data.totalUsers.nonBinaryOther.percentage.toFixed(1) },
            ],
            statsType: "total_users",
            filters: { dateRange: { startDate: moment('2020-01-01'), endDate: moment() } },
            navigateUrl: "/user-management"
          },

          {
            title: "NEW SIGN-UPS",
            value: data.newSignups.total,
            icon: <NewSignupIcon />,
            accent: "#fff",
            href: "/analytics",
            breakdown: [
              { label: "MALE", count: data.newSignups.male.count, percent: data.newSignups.male.percentage.toFixed(1) },
              { label: "FEMALE", count: data.newSignups.female.count, percent: data.newSignups.female.percentage.toFixed(1) },
              { label: "NON BINARY/OTHER", count: data.newSignups.nonBinaryOther.count, percent: data.newSignups.nonBinaryOther.percentage.toFixed(1) },
            ],
            statsType: "new_signup",
            navigateUrl: "/user-management"
          },

          {
            title: "ORGANIC SIGN-UPS",
            value: data.organicSignups.total,
            icon: <OrganicIcon />,
            accent: "#fff",
            href: "/analytics",
            breakdown: [
              { label: "MALE", count: data.organicSignups.male.count, percent: data.organicSignups.male.percentage.toFixed(1) },
              { label: "FEMALE", count: data.organicSignups.female.count, percent: data.organicSignups.female.percentage.toFixed(1) },
              { label: "NON BINARY/OTHER", count: data.organicSignups.nonBinaryOther.count, percent: data.organicSignups.nonBinaryOther.percentage.toFixed(1) },
            ],
            statsType: "organic_signups",
            navigateUrl: "/user-management"
          },

          {
            title: "MARKETING SIGN-UPS",
            value: data.marketingSignups.total,
            icon: <MarktingSignupIcon />,
            accent: "#fff",
            href: "/analytics",
            breakdown: [
              { label: "MALE", count: data.marketingSignups.male.count, percent: data.marketingSignups.male.percentage.toFixed(1) },
              { label: "FEMALE", count: data.marketingSignups.female.count, percent: data.marketingSignups.female.percentage.toFixed(1) },
              { label: "NON BINARY/OTHER", count: data.marketingSignups.nonBinaryOther.count, percent: data.marketingSignups.nonBinaryOther.percentage.toFixed(1) },
            ],
            statsType: "marketing_signups",
            navigateUrl: "/user-management"
          },

          {
            title: "COMPLETED SIGNUP",
            value: data.completedSignup.total,
            icon: <CompletedSignupIcon />,
            accent: "#fff",
            href: "/user-management",
            breakdown: [
              { label: "MALE", count: data.completedSignup.male.count, percent: data.completedSignup.male.percentage.toFixed(1) },
              { label: "FEMALE", count: data.completedSignup.female.count, percent: data.completedSignup.female.percentage.toFixed(1) },
              { label: "NON BINARY/OTHER", count: data.completedSignup.nonBinaryOther.count, percent: data.completedSignup.nonBinaryOther.percentage.toFixed(1) },
            ],
            statsType: "complete_signup",
            navigateUrl: "/user-management"
          },

          {
            title: "APPROVED",
            value: data.approvedUsers?.total ?? 0,
            icon: <CompletedSignupIcon />,
            accent: "#fff",
            href: "/user-management",
            breakdown: [
              { label: "MALE", count: data.approvedUsers?.male?.count ?? 0, percent: (data.approvedUsers?.male?.percentage ?? 0).toFixed(1) },
              { label: "FEMALE", count: data.approvedUsers?.female?.count ?? 0, percent: (data.approvedUsers?.female?.percentage ?? 0).toFixed(1) },
              { label: "NON BINARY/OTHER", count: data.approvedUsers?.nonBinaryOther?.count ?? 0, percent: (data.approvedUsers?.nonBinaryOther?.percentage ?? 0).toFixed(1) },
            ],
            statsType: "approved_users",
            navigateUrl: "/user-management"
          },

          {
            title: "ONLINE NOW",
            value: data.onlineNow.total,
            icon: <OnlineNowIcon />,
            accent: "#fff",
            percentage: data.onlineNow.change + "%",
            percentageColor: "success.main",
            href: "/user-management",
            breakdown: [
              { label: "MALE", count: data.onlineNow.male.count, percent: data.onlineNow.male.percentage },
              { label: "FEMALE", count: data.onlineNow.female.count, percent: data.onlineNow.female.percentage },
              { label: "NON BINARY/OTHER", count: data.onlineNow.nonBinaryOther.count, percent: data.onlineNow.nonBinaryOther.percentage },
            ],
            statsType: "online_now",
            navigateUrl: "/user-management"
          },

          {
            title: "INACTIVE",
            value: data.inactiveUsers?.total ?? 0,
            icon: <DeActivaredIcon />,
            accent: "#fff",
            href: "/user-management",
            breakdown: [
              { label: "MALE", count: data.inactiveUsers?.male?.count ?? 0, percent: (data.inactiveUsers?.male?.percentage ?? 0).toFixed(1) },
              { label: "FEMALE", count: data.inactiveUsers?.female?.count ?? 0, percent: (data.inactiveUsers?.female?.percentage ?? 0).toFixed(1) },
              { label: "NON BINARY/OTHER", count: data.inactiveUsers?.nonBinaryOther?.count ?? 0, percent: (data.inactiveUsers?.nonBinaryOther?.percentage ?? 0).toFixed(1) },
            ],
            statsType: "inactive_users",
            navigateUrl: "/user-management"
          },

          {
            title: "GHOST USERS",
            value: data.ghostUsers.total,
            icon: <GhostUsersIcon />,
            accent: "#fff",
            href: "/user-management",
            breakdown: [
              { label: "MALE", count: data.ghostUsers.male.count, percent: data.ghostUsers.male.percentage.toFixed(1) },
              { label: "FEMALE", count: data.ghostUsers.female.count, percent: data.ghostUsers.female.percentage.toFixed(1) },
              { label: "NON BINARY/OTHER", count: data.ghostUsers.nonBinaryOther.count, percent: data.ghostUsers.nonBinaryOther.percentage.toFixed(1) },
            ],
            statsType: "ghost_users",
            navigateUrl: "/user-management"
          },
          {
            title: "CONVERSATION",
            value: data?.conversationUser?.total,
            icon: <InituateIcon />,
            accent: "#fff",
            href: "/chat",
            percentage: (data?.conversationUser?.changePercentage ?? 0)?.toFixed(1) + "%",
            percentageColor: data?.conversationUser?.changePercentage>0 ? "success.main" : "error.main",
            breakdown: [
              { label: "MALE", count: data?.conversationUser?.male?.count, percent: data?.conversationUser?.male?.percentage.toFixed(1) },
              { label: "FEMALE", count: data?.conversationUser?.female?.count, percent: data?.conversationUser?.female?.percentage.toFixed(1) },
              { label: "NON BINARY/OTHER", count: data?.conversationUser?.nonBinaryOther?.count, percent: data?.conversationUser?.nonBinaryOther?.percentage.toFixed(1) },
            ],
          },

          {
            title: "DE-ACTIVATED USERS",
            value: data.deactivatedUsers.total,
            icon: <DeActivaredIcon />,
            accent: "#fff",
            percentage: data.deactivatedUsers.change + "%",
            percentageColor: "error.main",
            href: "/user-management",
            breakdown: [
              { label: "MALE", count: data.deactivatedUsers.male.count, percent: data.deactivatedUsers.male.percentage },
              { label: "FEMALE", count: data.deactivatedUsers.female.count, percent: data.deactivatedUsers.female.percentage },
              { label: "NON BINARY/OTHER", count: data.deactivatedUsers.nonBinaryOther.count, percent: data.deactivatedUsers.nonBinaryOther.percentage },
            ],
            statsType: "deactivated_accounts",
            navigateUrl: "/user-management"
          },

          {
            title: "SUSPENDED USERS",
            value: data.suspendedUsers.total,
            icon: <SuspendedUsersIcon />,
            accent: "#fff",
            percentage: data.suspendedUsers.change + "%",
            percentageColor: "error.main",
            href: "/user-management",
            breakdown: [
              { label: "MALE", count: data.suspendedUsers.male.count },
              { label: "FEMALE", count: data.suspendedUsers.female.count },
              { label: "NON BINARY/OTHER", count: data.suspendedUsers.nonBinaryOther.count },
            ],
            statsType: "suspended_users",
            navigateUrl: "/user-management"
          },

          {
            title: "HIDDEN",
            value: data.hiddenUsers?.total ?? 0,
            icon: <SuspendedUsersIcon />,
            accent: "#fff",
            percentage: (data.hiddenUsers?.change ?? 0) + "%",
            percentageColor: "error.main",
            href: "/user-management",
            breakdown: [
              { label: "MALE", count: data.hiddenUsers?.male?.count ?? 0 },
              { label: "FEMALE", count: data.hiddenUsers?.female?.count ?? 0 },
              { label: "NON BINARY/OTHER", count: data.hiddenUsers?.nonBinaryOther?.count ?? 0 },
            ],
            statsType: "hidden_by_admin",
            navigateUrl: "/user-management"
          },

          {
            title: "PROFILE COMPLETION RATE",
            value: `${data.profileCompletionRate.value.toFixed(1)}%`,
            icon: <ProfileCompletionRateIcon />,
            accent: "#fff",
            href: "/",
            breakdown: [
              { label: "COMPLETED", count: data.profileCompletionRate.completedInRange },
              { label: "TOTAL USERS", count: data.profileCompletionRate.totalUsersInRange },
            ],
          },

          {
            title: "PLAN VIEWED",
            value: data.planViewed.totalCurrent,
            icon: <PlanViewdIcon />,
            accent: "#fff",
            href: "/financials",
          },

          {
            title: "VERIFICATION PENDING",
            value: data.verificationPending.current.document + data.verificationPending.current.selfie,
            icon: <VerificationPendingIcon />,
            accent: "#fff",
            href: "/verification",
            breakdown: [
              { label: "SELFIE", count: data.verificationPending.current.selfie },
              { label: "DOCUMENT", count: data.verificationPending.current.document },
            ],
            statsType: "verification_pending",
            navigateUrl: "/verification",
            filters: { activeVerificationTab: "Pending Requests" },
          },

          {
            title: "UNREAD BOT CHATS",
            value: data.unreadBotChats.value,
            icon: <UnreadBotIcon />,
            accent: "#fff",
            href: "/chat",
            statsType: "unread_bot_chats",
            navigateUrl: "/chat",
            filters: { filterType: "Unread Messages" }
          },

          {
            title: "PENDING TICKETS",
            value: data.pendingTickets.value,
            icon: <PendingTicketIcon />,
            accent: "#fff",
            href: "/QueryTicketManagement",
            statsType: "pending_tickets",
            navigateUrl: "/QueryTicketManagement",
            filters: { activeVerificationTab: "Pending Requests" },
          },
          {
            title: "TOTAL SUBSCRIPTION",
            value: data.totalSubscription.total,
            icon: <PaymentIcon />,
            accent: "#fff",
            href: "/financials",
            breakdown: [
              { label: "MALE", count: data.totalSubscription.male.count, percent: data.totalSubscription.male.percentage.toFixed(1) },
              { label: "FEMALE", count: data.totalSubscription.female.count, percent: data.totalSubscription.female.percentage.toFixed(1) },
              { label: "NON BINARY/OTHER", count: data.totalSubscription.nonBinaryOther.count, percent: data.totalSubscription.nonBinaryOther.percentage.toFixed(1) },
            ],
            statsType: null,
            resetFilters: true,
            navigateUrl: "/financials",
            filters: { dateRange: { startDate: moment('2020-01-01'), endDate: moment() } }
          },
          {
            title: "TODAY SUBSCRIPTION",
            value: data.todaySubscription.total,
            icon: <PaymentIcon />,
            accent: "#fff",
            href: "/financials",
            breakdown: [
              { label: "MALE", count: data?.todaySubscription?.male.count, percent: data?.todaySubscription?.male.percentage.toFixed(1) },
              { label: "FEMALE", count: data?.todaySubscription?.female.count, percent: data?.todaySubscription?.female.percentage.toFixed(1) },
              { label: "NON BINARY/OTHER", count: data?.todaySubscription?.nonBinaryOther.count, percent: data?.todaySubscription?.nonBinaryOther.percentage.toFixed(1) },
            ],
            statsType: "today_subscription",
            navigateUrl: "/financials",
            filters: { dateRange: { startDate: moment(), endDate: moment() } }
          },
          {
            title: "YESTERDAY SUBSCRIPTION",
            value: data.yesterdaySubscription.total,
            icon: <PaymentIcon />,
            accent: "#fff",
            href: "/financials",
            breakdown: [
              { label: "MALE", count: data?.yesterdaySubscription?.male.count, percent: data?.yesterdaySubscription?.male.percentage.toFixed(1) },
              { label: "FEMALE", count: data?.yesterdaySubscription?.female.count, percent: data?.yesterdaySubscription?.female.percentage.toFixed(1) },
              { label: "NON BINARY/OTHER", count: data?.yesterdaySubscription?.nonBinaryOther.count, percent: data?.yesterdaySubscription?.nonBinaryOther.percentage.toFixed(1) },
            ],
            statsType: "yesterday_subscription",
            navigateUrl: "/financials",
            filters: { dateRange: { startDate: moment().subtract(1, 'days'), endDate: moment().subtract(1, 'days') } }
          },
        ]
        : [];

      setCardsData(cards);
      setIsLoading(false);
    } catch (err) {
      console.error('Error while loading user data', err);
    }
  };
  useEffect(() => {
    fetchData();
  }, [filter]);

  const handleNaviagtion = (card) => {
    if (card?.navigateUrl) {
      if (card?.resetFilters) {
        dispatch(setResetFilter())
      }
      dispatch(setStatsTypeFilter({
        statsTitle: card?.title,
        statsType: card?.statsType ?? null,
        profileCompilation: null,
        searchTerm: null,
        ...(card?.filters ?? {}),
      }))
      navigate(card?.navigateUrl)
    }
  }

  return (
    <Box>
      <Box sx={{ maxWidth: 1900, mx: "auto" }}>
        <Grid container spacing={2}>
          {cardsData.map((c, i) => (
            <Grid item xs={12} sm={6} md={4} lg={4} key={i} >
              <DashboardCard card={c} handleNaviagtion={handleNaviagtion}/>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  );
}
